class CardsSwiper {
    constructor() {
        this.homeCarousel = document.querySelector('.block-slides_block');
        this.blockSlides = document.querySelector(".block-slides_block, .block-carousel" );
        if (!this.blockSlides) {
            return;
        }
        this.prevArrow = this.blockSlides.querySelector('.prev-btn');
        this.nextArrow = this.blockSlides.querySelector('.next-btn');
        this.swiperCards = new Swiper(".swiper-cards", {
            slidesPerView: 2,
            spaceBetween: 30,
            loop: true,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                },

                990: {
                    slidesPerView: 4,
                    spaceBetween: 80,
                },

                2000: {
                    slidesPerView: 4,
                    spaceBetween: 80,
                }
            },
            navigation: {
                nextEl: this.nextArrow,
                prevEl: this.prevArrow,
                clickable: true,
            }
        });

        if (!this.homeCarousel) {
            return;
        }

        this.swiperCards = new Swiper(".swiper-cards", {
            slidesPerView: 2,
            spaceBetween: 30,
            loop: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                },

                990: {
                    slidesPerView: 2,
                    spaceBetween: 80,
                },

                2000: {
                    slidesPerView: 2,
                    spaceBetween: 80,
                }
            },
            navigation: {
                nextEl: this.nextArrow,
                prevEl: this.prevArrow,
                clickable: true,
            }
        });
    }
}